module.exports = __webpack_public_path__ + "media/images/application2/AppMfaIdentityVerification__dl__item--3-bbc667d396cf5721232559d036ba0194.svg";